import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { reportChat } from './chat.api';
import type { ReportChatRequest } from './chat.type';

export const useReportChat = () => {
  return useMutation({
    mutationFn: (data: ReportChatRequest) => reportChat(data),
    onSuccess: () => {
      toast.success('Report chat submitted successfully');
    },
  });
};
